import { ButtonBase, Grid, Box } from "@material-ui/core";
import { useStyles } from "./CustomAppBar.styles";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import defualtProfileImage from "../../assets/svgs/default-profile-image.svg";
import { useNavigate } from "react-router-dom";
import promzzy from "../../assets/images/promzzy3.jpg";
import { RESUME_LINK } from "../../utils/constants";

type propsType = {
  colorChange: boolean;
};

function CustomAppBar({ colorChange }: propsType) {
  const classes = useStyles();
  const history = useNavigate();

  const nav = [
    { title: "Home", id: 1, value: "HOME" },
    { title: "About", id: 1, value: "ABOUT" },
    { title: "Skills", id: 1, value: "SKILL" },
    { title: "Experience", id: 1, value: "EXPERIENCE" },
    { title: "Portfolio", id: 1, value: "PORTFOLIO" },
  ];

  return (
    <Grid
      className={`${classes.root} ${colorChange ? "bgNavBar" : "notScrolled"}`}
      xs={12}
    >
      <Box className={classes.display_picture}>
        <img src={promzzy ? promzzy : defualtProfileImage} alt="promise" />
      </Box>
      <Grid className={classes.navRight}>
        <Box className={classes.navContent}>
          {nav.map((path) => (
            <ButtonBase
              onClick={() => {
                if (path.value === "HOME") {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  return;
                }
                history("/", { state: path.value });
              }}
              className={classes.navPath}
            >
              {path.title}
            </ButtonBase>
          ))}
          <a
            rel="noreferrer"
            href={RESUME_LINK}
            target="_blank"
            download="Promise Stephen.pdf"
          >
            <ButtonBase className={classes.downloadCvBtn}>
              <span>Resume</span>
              <CloudDownloadIcon className={classes.downloadIcon} />
            </ButtonBase>
          </a>
        </Box>
      </Grid>
      <Box className={classes.smallScreenCvBtn}>
        <a
          rel="noreferrer"
          href={RESUME_LINK}
          target="_blank"
          download="Promise Stephen.pdf"
        >
          <ButtonBase className={classes.downloadCvBtn}>
            <span>Resume</span>
            <CloudDownloadIcon className={classes.downloadIcon} />
          </ButtonBase>
        </a>
      </Box>
    </Grid>
  );
}

export default CustomAppBar;
